import { mergeClassNames } from "utils/common";

const PrefixColumn = ({ isExpanded, ...props }) => {
	return <span {...props} className={mergeClassNames("vs--table-expandable-icon vs--font-bigest", isExpanded && "vs--table-expandable-icon-open", props.className)} />;
};

export default PrefixColumn;
